export const BWSL_SEASON = '2024/25';
export const BWSL_CURRENT_GW = 16;
export const BWSL_TOTAL_GW = 22;
export const BWSL_STANDINGS = [
    { pos:1, name:'Anderlecht W',   short:'AND', color:'#9B1B2A', p:16, w:13, d:2, l:1, gf:48, ga:14, form:['W','W','W','D','W'], zone:'cl',  pts:41 },
    { pos:2, name:'Club Brugge W',  short:'CLU', color:'#002F6C', p:16, w:12, d:1, l:3, gf:42, ga:18, form:['W','D','W','W','L'], zone:'cl',  pts:37 },
    { pos:3, name:'Standard W',     short:'STD', color:'#CC0000', p:16, w:9,  d:3, l:4, gf:33, ga:22, form:['W','W','L','D','W'], zone:'cl',  pts:30 },
    { pos:4, name:'Gent W',         short:'GNT', color:'#003366', p:16, w:8,  d:2, l:6, gf:28, ga:26, form:['L','W','W','D','W'], zone:'',    pts:26 },
    { pos:5, name:'Genk W',         short:'GNK', color:'#0066CC', p:16, w:6,  d:3, l:7, gf:24, ga:28, form:['W','L','D','W','L'], zone:'',    pts:21 },
    { pos:6, name:'OHL Leuven W',   short:'OHL', color:'#FF6600', p:16, w:5,  d:2, l:9, gf:18, ga:32, form:['L','W','L','D','W'], zone:'',    pts:17 },
    { pos:7, name:'Westerlo W',     short:'WES', color:'#FFCC00', p:16, w:3,  d:2, l:11,gf:14, ga:40, form:['L','L','D','L','W'], zone:'rel', pts:11 },
    { pos:8, name:'Charleroi W',    short:'CHA', color:'#000000', p:16, w:1,  d:3, l:12,gf:10, ga:48, form:['L','L','L','D','L'], zone:'rel', pts:6  },
];
export const BWSL_SCORERS = [
    { name:'Tine De Caigny',   initials:'TD', club:'Anderlecht W',  goals:14 },
    { name:'Nicky Evrard',     initials:'NE', club:'Club Brugge W', goals:0  },
    { name:'Davina Philtjens', initials:'DP', club:'Anderlecht W',  goals:8  },
    { name:'Hannah Eurlings',  initials:'HE', club:'Club Brugge W', goals:9  },
    { name:'Amber Maximus',    initials:'AM', club:'Standard W',    goals:7  },
];
export const BWSL_FIXTURES = [
    { date:'2025-03-09', home:'Anderlecht W',  away:'Standard W',    homeGoals:3, awayGoals:1, status:'FT', homeColor:'#9B1B2A', awayColor:'#CC0000' },
    { date:'2025-03-16', home:'Club Brugge W', away:'Gent W',        homeGoals:2, awayGoals:0, status:'FT', homeColor:'#002F6C', awayColor:'#003366' },
    { date:'2025-03-23', home:'Standard W',    away:'Genk W',        homeGoals:1, awayGoals:1, status:'FT', homeColor:'#CC0000', awayColor:'#0066CC' },
    { date:'2025-04-27', home:'Anderlecht W',  away:'Club Brugge W', homeGoals:0, awayGoals:0, status:'NS', homeColor:'#9B1B2A', awayColor:'#002F6C' },
    { date:'2025-05-04', home:'Gent W',        away:'Standard W',    homeGoals:0, awayGoals:0, status:'NS', homeColor:'#003366', awayColor:'#CC0000' },
];
export function bwslPts(t) { return t.w * 3 + t.d; }
export function bwslGD(t)  { return t.gf - t.ga; }

export async function fetchLiveBWSLData() {
    const PROXY_URL = 'https://bwsl-proxy.footballgirl.workers.dev';
    try {
        const res = await fetch(PROXY_URL, { signal: AbortSignal.timeout(5000) });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        if (!data.standings || !data.standings.length) throw new Error('empty');
        return {
            standings: data.standings,
            scorers:   BWSL_SCORERS,
            fixtures:  BWSL_FIXTURES,
        };
    } catch (e) {
        console.warn('[fetchLiveBWSLData] proxy failed, using fallback:', e.message);
        return null;
    }
}
